import { BasicAsyncSelect } from '@/view/components/BasicAsyncSelect'
import { useFormContext } from 'react-hook-form'
import { FilterFormData } from './FilterReports'
import { useCallback } from 'react'
import { MultiValue } from 'react-select'
import { OptionType } from '@/app/utils/optionSelectType'
import { useSellers } from '@/app/hooks/useSellers'
import { UserRoleEnum } from '@/app/services/usersService/user'

interface ManagersProps {
  opt: MultiValue<OptionType>
  setOpt: React.Dispatch<React.SetStateAction<MultiValue<OptionType>>>
}

export default function Managers({ opt, setOpt }: ManagersProps) {
  const {
    setValue,
    formState: { errors },
  } = useFormContext<FilterFormData>()

  const handleSelect = (optionSelected: MultiValue<OptionType>) => {
    const value = optionSelected?.map((option) => option.value) || undefined

    setValue('managerIds', value as unknown as string)
    setOpt(optionSelected)
  }

  const {
    data: fullSellerData,
    isFetching,
    isLoading,
    fetchNextPage,
    hasNextPage,
    setParams: setQueryParams,
  } = useSellers({ initialLimit: 10, role: UserRoleEnum.MANAGER })

  const sellerData = fullSellerData?.pages.flatMap((page) =>
    page.users.map((user) => ({
      value: user._id,
      label: user.name,
    })),
  )

  const handleLoadMore = useCallback(() => {
    if (hasNextPage && !isFetching) {
      fetchNextPage()
    }
  }, [fetchNextPage, hasNextPage, isFetching])

  return (
    <div className="space-y-2">
      <h3 className="font-medium text-black04">Gerente</h3>
      <BasicAsyncSelect
        data={sellerData}
        handleSelectedValue={handleSelect}
        isLoading={isFetching || isLoading}
        onMenuScrollToBottom={handleLoadMore}
        placeholder="Selecione o(s) gerente(s)"
        setParams={setQueryParams}
        value={opt}
        inputError={errors.managerIds?.message}
      />
    </div>
  )
}
